import { render, staticRenderFns } from "./BaseValInput.vue?vue&type=template&id=a8174014&"
import script from "./BaseValInput.vue?vue&type=script&lang=js&"
export * from "./BaseValInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports